define('home/views/ExploreView',[
    'core/switches',
    'core/constants/exploreModuleConstants',

    'home/models/Session',
    'home/views/common/TabbedView',
    'home/views/common/FetchableCollectionLayout',
    'home/views/HideOnEndFooterView',
    'home/views/ExploreChannelGroupsView',
    'home/views/ExploreChannelGroupsReactViewWrapper',
    'home/views/AllstarCollectionView',

    'home/templates/explore',
], function (
    switches,
    exploreModuleConstants,

    Session,
    TabbedView,
    FetchableCollectionLayout,
    HideOnEndFooterView,
    ExploreChannelGroupsView,
    ExploreChannelGroupsReactViewWrapper,
    AllstarCollectionView,

    exploreTemplate
) {
    'use strict';

    var homeReact = switches.isFeatureActive('homeReact');

    /**
     * This is the view shown for Explore nav item. Shows tabs the user can
     * explore on the left, and the content in the center.
     */
    var ExploreView = TabbedView.extend({
        defaultTab: 'channels',

        template: exploreTemplate,
        templateHelpers: function () {
            return {
                // Need to be authenticated to fetch all stars list
                showPeople: !Session.isKnownToBeLoggedOut(),
            };
        },

        initialize: function (options) {
            options = options || {};
            TabbedView.prototype.initialize.call(this, options);
            this.channelId = options.channelId;
            this.channelFeed = options.channelFeed;
            this.session = Session.get();

            this.listenTo(this, 'change:activeTab', this.updateHeader);
        },

        updateHeader: function (activeTab) {
            this.$('[data-role=header]').addClass('hidden');
            this.$('[data-role=header][data-tab=' + activeTab + ']').removeClass('hidden');
        },

        getTabView: function (activeTab) {
            var channelGroupTabs = exploreModuleConstants.TABS;

            switch (activeTab) {
            case 'channels':
                this.model.exploreChannelCollection.ensureFetched();
                if (homeReact) {
                    return new ExploreChannelGroupsReactViewWrapper({
                        channelGroupsCollection: this.model.exploreChannelCollection,
                        rankings: [channelGroupTabs.TOP, channelGroupTabs.POPULAR, channelGroupTabs.RECENT],
                        explorePath: activeTab,
                    });
                }

                return new ExploreChannelGroupsView({
                    collection: this.model.exploreChannelCollection,
                    activeTab: this.channelId,
                    channelFeed: this.channelFeed,
                    channelTabs: [channelGroupTabs.TOP, channelGroupTabs.POPULAR, channelGroupTabs.RECENT],
                    exploreTab: activeTab,
                });
            case 'people':
                this.model.allStars.ensureFetched();
                return new FetchableCollectionLayout({
                    model: this.model.allStars,
                    collection: this.model.allStars.items,
                    fetchableCollectionView: AllstarCollectionView,
                    fetchableCollectionFooterView: HideOnEndFooterView,
                    infiniteScroll: true,
                });
            case 'discussions':
                this.model.exploreChannelCollection.ensureFetched();
                return new ExploreChannelGroupsView({
                    collection: this.model.exploreChannelCollection,
                    activeTab: this.channelId,
                    channelFeed: this.channelFeed,
                    channelTabs: [channelGroupTabs.DISCUSSIONS],
                    exploreTab: activeTab,
                });
            }
        },
    });

    return ExploreView;
});

